export const formatKwNumber = (kwNumber: string) => {
    if (kwNumber.startsWith('KW ')) {
        return kwNumber.slice(3);
    } else if (kwNumber.startsWith('KW')) {
        return kwNumber.slice(2);
    }

    return kwNumber.toUpperCase();
};
